import React from "react"
import "./Checkbox.scss"

const Checkbox: React.FC<React.PropsWithChildren<{selected: boolean, onChange(val: boolean): void, error?: string, label: string}>> = ({selected, onChange, error, label}) => {
  const cbClassName = [
    "neo__raffleCb",
    selected ? "neo__raffleCb--selected" : "neo__raffleCb--notSelected",
    error ? "neo__raffleCb--error" : "neo__raffleCb--noError",
  ].join(" ")

  return <div className="neo__raffleCB__holder">
    {error && <div className="neo__raffleCB__error">{error}</div>}

    <div className="neo__raffleCB__cbWithLabelHolder">
      <a className={cbClassName} onClick={() => onChange(!selected)} />
      <div className="neo__raffleCB__label">
        <label>
          <input type="checkbox" style={{ display: "none" }} checked={selected} onChange={(evt) => onChange(evt.target.checked)}/>
          <span dangerouslySetInnerHTML={{__html: label}} />
        </label>
      </div>
    </div>
  </div>
}

export default Checkbox
